import { idbBackend } from './db';
import { graphTransport } from './graphTransport';
import { createSessionStore } from './auditSessions';
import { SyncEngine } from './syncEngine';
import { TaskOutbox } from './taskOutbox';
import { idbOutboxBackend } from './outboxDb';
import { taskOutboxSender } from '../data/taskOutboxSender';
import { getActiveAccount } from '../auth/msal';

/** The browser's current sign-in (MSAL's active account — every tab shares it); null = unknown. */
function activeAccountId(): string | null {
  try {
    return getActiveAccount()?.homeAccountId ?? null;
  } catch {
    return null;
  }
}

/** App-wide singletons: one session store, one sync engine. */
export const sessionStore = createSessionStore(idbBackend);

let engine: SyncEngine | null = null;

export function getSyncEngine(): SyncEngine {
  if (!engine) {
    engine = new SyncEngine(idbBackend, graphTransport);
    // Shared devices: nothing syncs until App.tsx names the signed-in account.
    engine.requireOwner();
    engine.setAccountCheck(activeAccountId);
  }
  return engine;
}

let outbox: TaskOutbox | null = null;

/** The task outbox (B4): comments/files written with no signal, sent when it returns. */
export function getTaskOutbox(): TaskOutbox {
  if (!outbox) {
    outbox = new TaskOutbox(idbOutboxBackend, taskOutboxSender);
    // Shared devices: nothing shows or sends until App.tsx names the signed-in account.
    outbox.requireOwner();
    outbox.setAccountCheck(activeAccountId);
  }
  return outbox;
}
